import { IoCheckbox } from "react-icons/io5";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { MdInfoOutline } from "react-icons/md";

export default function Checkbox(props) {
  const { CommonStore, RecuiterStore } = useStores();
  return useObserver(() => (
    <div
      className="flex flex-col cursor-pointer z-10 "
      onClick={() => {
        console.log(
          RecuiterStore.jobPostEditable,
          "job Post Editable",
          props.ind,
          "props.ind"
        );
        if (props.active || props.isEdit) {
          CommonStore.setBotLabel(props.label);
          CommonStore.setProgress(props.ind);
        }

        console.log(props);
      }}
    >
      {props.completed && props.active ? (
        <IoCheckbox className="md:text-4xl lg:text-4xl text-3xl bg-white text-primary" />
      ) : props.skipped ? (
        <MdInfoOutline className="md:text-4xl lg:text-4xl text-3xl rounded-lg p-2 bg-[#ffffff] border border-[#FFB82B] text-[#FFB82B]" />
      ) : (
        <IoCheckbox className="md:text-4xl lg:text-4xl text-3xl bg-white text-[#D2D1D1] m-0 p-0" />
      )}
      <span
        className={`${
          props.completed && props.active
            ? "text-primary"
            : props.skipped
            ? "text-[#FFB82B]"
            : "text-[#ACACAC]"
        } w-20 sm:w-36 md:w-36 lg:w-36`}
      >
        {props.label}
      </span>
      {props.skipped && (
        <span className="text-yellow text-xs whitespace-nowrap">
          ( Skipped )
        </span>
      )}
    </div>
  ));
}
